import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import { useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import Taptop from "./TapTop";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ThemeCustomize from "../Layout/ThemeCustomizer";
import Footer from "./Footer";
import CustomizerContext from "../_helper/Customizer";
import AnimationThemeContext from "../_helper/AnimationTheme";
import ConfigDB from "../Config/ThemeConfig";
import Loader from "./Loader";
import { MENUITEMS } from "./Sidebar/Menu";
import useRbac from "../Hooks/useRbac";

const AppLayout = ({ children, classNames, ...rest }) => {
  const { layout } = useContext(CustomizerContext);
  const { sidebarIconType } = useContext(CustomizerContext);
  const userRole = JSON.parse(localStorage.getItem('role_name'))
  const { isSuperAdmin, canAny } = useRbac();

  const layout1 = localStorage.getItem("sidebar_layout") || layout;
  const sideBarIcon = localStorage.getItem("sidebar_icon_type") || sidebarIconType;
  const location = useLocation();
  const { animation } = useContext(AnimationThemeContext);
  const animationTheme = localStorage.getItem("animation") || animation || ConfigDB.data.router_animation;

  const isVisible = (entry) => {
    if (isSuperAdmin) return true;
    const hasPerms = Array.isArray(entry.permissions) && entry.permissions.length > 0;
    const hasRoles = Array.isArray(entry.roles) && entry.roles.length > 0;
    if (!hasPerms && !hasRoles) return true;
    if (hasPerms && canAny(entry.permissions)) return true;
    if (hasRoles && entry.roles.some((r) => userRole === r)) return true;
    return false;
  };

  const filterMenuItemsByRole = (menuItems) =>
    menuItems.map((menu) => {
      const filteredItems = menu.Items.flatMap((item) => {
        if (!isVisible(item)) return [];
        if (Array.isArray(item.children) && item.children.length > 0) {
          const visibleChildren = item.children.filter(isVisible);
          if (visibleChildren.length === 0) return [];
          return [{ ...item, children: visibleChildren }];
        }
        return [item];
      });
      return { ...menu, Items: filteredItems };
    });

  const filteredMenuItems = filterMenuItemsByRole(MENUITEMS);

  return (
    <Fragment>
      <Loader />
      <Taptop />
      <div className={`page-wrapper ${layout1}`} sidebar-layout={sideBarIcon} id="pageWrapper">
        <Header />
        <div className="page-body-wrapper">
          <Sidebar menuItems={filteredMenuItems} />
          <TransitionGroup {...rest}>
            <CSSTransition key={location.key} timeout={100} classNames={animationTheme} unmountOnExit>
              <div className="page-body">
                <div>
                  <div>
                    <Outlet />
                  </div>
                </div>
              </div>
            </CSSTransition>
          </TransitionGroup>
          <Footer />
        </div>
      </div>
      <ThemeCustomize />
      <ToastContainer />
    </Fragment>
  );
};
export default AppLayout;


